








import Vue from 'vue';

export default Vue.extend({
  name: 'circle-component',
  props: {
    width: { default: 472, type: Number },
    height: { default: 472, type: Number },
    position: { default: '', type: String }
  },
  computed: {
    style() {
      return {
        // @ts-ignore
        width: `${this.$props.width}px`,
        // @ts-ignore
        height: `${this.$props.height}px`
      };
    }
  }
});
